export default function initPricingSelector() {
    const planDropdown = document.getElementById( 'plan-dropdown' );
    const originalSelect = planDropdown;
    const priceValueElement = document.querySelector( '.price-value' );
    const trialButton = document.querySelector( '.btn-primary' );
    const marketplaceBeforeTextElement = document.querySelector( '.marketplace-before-text' );

    if ( ! originalSelect || ! priceValueElement || ! trialButton || ! marketplaceBeforeTextElement ) {
        return;
    }

    const pricingData = getPricingData( originalSelect );

    let selectedText = '';

    Array.from( originalSelect.options ).forEach( ( option ) => {
        if ( option.selected ) {
            selectedText = option.textContent;
        }
    } );

    const selectWrapper = document.createElement( 'div' );
    selectWrapper.className = 'trial-select-wrapper position-relative w-100';

    let optionsHTML = '';
    Array.from( originalSelect.options ).forEach( ( option ) => {
        const value = option.value;
        const text = option.textContent;
        const isSelected = option.selected;

        const selectedClass = isSelected ? 'selected' : '';
        optionsHTML += '<div class="trial-option position-relative d-flex justify-content-between align-items-center p-2 ' +
            selectedClass + '" data-value="' + value + '">' +
            '<span>' + text + '</span>' +
            '<span class="checkmark fs-5">✓</span>' +
            '</div>';
    } );

    const innerHtml = '<div class="trial-select position-relative w-100">' +
        '<div class="trial-select-trigger ps-2 p-3 border rounded-3 d-flex justify-content-between align-items-center">' +
        selectedText +
        '</div>' +
        '<div class="trial-options position-absolute top-100 start-0 end-0 bg-white border rounded-1 shadow-lg mt-1">' +
        optionsHTML +
        '</div>' +
        '</div>';

    selectWrapper.innerHTML = innerHtml;

    originalSelect.classList.add( 'd-none' );
    originalSelect.parentNode.insertBefore( selectWrapper, originalSelect );

    const customSelect = selectWrapper.querySelector( '.trial-select' );
    const selectTrigger = selectWrapper.querySelector( '.trial-select-trigger' );
    const options = selectWrapper.querySelectorAll( '.trial-option' );

    for ( let i = 0; i < options.length; i++ ) {
        const customOption = options[ i ];
        customOption.addEventListener( 'click', function() {
            const value = this.getAttribute( 'data-value' );
            const text = this.querySelector( 'span' ).textContent;

            for ( let j = 0; j < options.length; j++ ) {
                options[ j ].classList.remove( 'selected' );
            }
            this.classList.add( 'selected' );

            selectTrigger.textContent = text;
            customSelect.classList.remove( 'opened' );

            originalSelect.value = value;

            const event = new Event( 'change' );
            originalSelect.dispatchEvent( event );
        } );
    }

    selectTrigger.addEventListener( 'click', function() {
        customSelect.classList.toggle( 'opened' );
    } );

    document.addEventListener( 'click', function( e ) {
        if ( ! customSelect.contains( e.target ) ) {
            customSelect.classList.remove( 'opened' );
        }
    } );

    function getPricingData( selectElement ) {
        try {
            return JSON.parse( selectElement.getAttribute( 'data-pricing' ) );
        } catch ( e ) {
            const errorMsg = 'Error parsing pricing data: ' + e.message;

            return null;
        }
    }

    const updatePriceDisplay = function() {
        const selectedPlan = originalSelect.value;
        const planPricingData = getPricingData( originalSelect );

        if ( ! planPricingData ) {
            return;
        }

        const planData = planPricingData.items.find( function( item ) {
            const planName = item.name.replace( /\[:.*?\]\[:.*?\]/, '' ).replace( /\[:.*?\]/, '' );
            return planName === selectedPlan;
        } );

        if ( ! planData ) {
            return;
        }

        priceValueElement.innerHTML = planData[ 'price-year' ];

        if ( planData[ 'btn-link' ] && trialButton ) {
            trialButton.href = planData[ 'btn-link' ];
        }

        if ( planData[ 'marketplace-before-text' ] ) {
            marketplaceBeforeTextElement.textContent = planData[ 'marketplace-before-text' ];
        }
    };

    originalSelect.addEventListener( 'change', updatePriceDisplay );

    updatePriceDisplay();
}
